module.exports = __webpack_public_path__ + "img/play-pause.21dfa314.svg";